import React, { useRef, useEffect, useState } from 'react';
import * as styles from './AWClientsSection.module.css';
import * as generalStyles from './AWGeneral.module.css';

export const AWClientsSection: React.FC = () => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            if (!containerRef.current) return;
            const rect = containerRef.current.getBoundingClientRect();
            const containerTop = rect.top + window.scrollY;
            const containerHeight = containerRef.current.offsetHeight;
            const viewportHeight = window.innerHeight;
            const scrollY = window.scrollY;

            const start = containerTop;
            const end = containerTop + containerHeight - viewportHeight;
            const progress = (scrollY - start) / (end - start);
            setScrollProgress(Math.max(0, Math.min(1, progress)));
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const getStatStyle = (index: number) => {
        // Elements always visible immediately
        return {
            opacity: 1,
            transform: 'translateY(0)',
            transitionDelay: '0s'
        };
    };

    // Smoother fade logic (mirrored from AboutSection)
    let contentOpacity = 0;
    if (scrollProgress < 0.15) {
        contentOpacity = scrollProgress / 0.15;
    } else if (scrollProgress > 0.85) {
        contentOpacity = 1 - (scrollProgress - 0.85) / 0.15;
    } else {
        contentOpacity = 1;
    }

    return (
        <div ref={containerRef} className={styles.scrollContainer}>
            <div className={styles.stickyViewport}>
                {/* Background Image (Full bleed) */}
                <div
                    className={styles.bgImage}
                    style={{
                        backgroundImage: "url('/assets/backgounds/aw_absect_001_item.jpeg')",
                        transform: scrollProgress > 0.3 ? 'scale(1.1)' : 'scale(1)',
                        transition: 'transform 10s ease-out'
                    }}
                />

                {/* 50/50 Layout */}
                <div
                    className={styles.layoutWrapper}
                    style={{ opacity: contentOpacity, transition: 'opacity 0.1s linear' }}
                >
                    {/* Empty left side for 50/50 layout */}
                    <div className={styles.visualSide} />

                    {/* Content (Right 50%) */}
                    <div className={styles.contentWrapper}>
                        {/* CLIENT LOGOS */}
                        <div className={styles.sectionTitle}>
                            CLIENTES DESTACADOS
                        </div>

                        <div className={styles.clientLogosContainer}>
                            <img
                                src="/assets/icons/aw_icons/001_lg_cl_mail.png"
                                alt="Client 1"
                                className={styles.clientLogo}
                                style={getStatStyle(0)}
                            />
                            <img
                                src="/assets/icons/aw_icons/002_lg_cl_mail.png"
                                alt="Client 2"
                                className={styles.clientLogo}
                                style={getStatStyle(1)}
                            />
                            <img
                                src="/assets/icons/aw_icons/003_lg_cl_mail.png"
                                alt="Client 3"
                                className={styles.clientLogo}
                                style={getStatStyle(2)}
                            />
                        </div>

                        {/* STATS NUMBERS */}
                        <div className={styles.statsGrid}>
                            <div className={styles.statItem} style={getStatStyle(3)}>
                                <span className={styles.statNumber}>+90</span>
                                <span className={styles.statLabel}>AÑOS DE EXPERIENCIA</span>
                            </div>
                            <div className={styles.statItem} style={getStatStyle(4)}>
                                <span className={styles.statNumber}>+10</span>
                                <span className={styles.statLabel}>AÑOS EN ARUBA</span>
                            </div>
                            <div className={styles.statItem} style={getStatStyle(5)}>
                                <span className={styles.statNumber}>+1000</span>
                                <span className={styles.statLabel}>CLIENTES ATENDIDOS</span>
                            </div>
                            <div className={styles.statItem} style={getStatStyle(6)}>
                                <span className={styles.statNumber}>+300</span>
                                <span className={styles.statLabel}>PRODUCTOS ÚNICOS</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Scroll Progress Bar (White) */}
                <div className={`${generalStyles.scrollProgressLine} ${generalStyles.dark} ${styles.sectionProgress}`}>
                    <div className={generalStyles.scrollProgressLabel}>PROGRESS</div>
                    <div
                        className={generalStyles.scrollProgressIndicator}
                        style={{ top: `${scrollProgress * 100}%` }}
                    />
                </div>
            </div>
        </div>
    );
};
